import styled from 'styled-components';

export const FullscreenWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FullscreenImageContainer = styled.div`
  position: relative;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
`;
